"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaginDiscountPercentage = exports.campaginImporterPercentage = exports.campaignDiscount = exports.campaignImporter = exports.calculateMarginAccessoriesValue = exports.calculateTotalMarginValueFromValue = exports.calcMarginPercentage = exports.calcMarginValueByAccessories = exports.calcMarginValue = void 0;
const enums_1 = require("../../enums");
const financing_1 = require("./financing");
const calcMarginValue = (vehicleConfiguration, order, margin) => {
    return (0, exports.calcMarginValueByAccessories)(vehicleConfiguration, order.accessories, margin);
};
exports.calcMarginValue = calcMarginValue;
const calcMarginValueByAccessories = (vehicleConfiguration, accessories, margin) => {
    var _a, _b, _c;
    return (0, exports.calculateTotalMarginValueFromValue)((margin === null || margin === void 0 ? void 0 : margin.discountValue) || 0, (margin === null || margin === void 0 ? void 0 : margin.importerDiscountValue) || 0, ((_a = vehicleConfiguration.pricing) === null || _a === void 0 ? void 0 : _a.retailerBasicMargin) || 0, totalMarginAccessories(accessories), varnishPrice(), Math.abs(((_b = vehicleConfiguration.pricing) === null || _b === void 0 ? void 0 : _b.importerSupportExcludingVat) || 0), Math.abs(((_c = vehicleConfiguration.pricing) === null || _c === void 0 ? void 0 : _c.customerAdvantageExcludingVat) || 0));
};
exports.calcMarginValueByAccessories = calcMarginValueByAccessories;
const calcMarginPercentage = (marginValue, order) => {
    const totalCustomerPrice = (0, financing_1.getCalculationPriceByType)(order, enums_1.FinancingType.CASH);
    if (totalCustomerPrice === 0)
        return 0;
    return +((marginValue / totalCustomerPrice) * 100).toFixed(1);
};
exports.calcMarginPercentage = calcMarginPercentage;
const varnishPrice = () => {
    return 0; // TODO PIM 2.0
};
const totalMarginAccessories = (accessories) => {
    return accessories.reduce((total, accessory) => {
        let priceAccessory = accessory === null || accessory === void 0 ? void 0 : accessory.retailerMargin;
        if (!priceAccessory) {
            let marginAccessory = (accessory === null || accessory === void 0 ? void 0 : accessory.priceExcludingVat) * 0.15 || 0; // fallback if missing retailerMargin // TODO PIM 2.0
            return total + marginAccessory;
        }
        return total + priceAccessory;
    }, 0);
};
/**
 * Calculate the Total margin (kr), input kr
 * @param discountInputValue Extra discount, input from sale
 * @param discountImporterInputValue Extra dicount from importer, input from sale
 * @param totalDefaultMargin Value from PIM
 * @param totalMarginAccessories Total margin of all accessories
 * @param totalMarginVarnish Total margin of lacq from PIM
 * @param campaignDiscountImporterValue Importer campaign discount PIM value
 * @param campaignDiscountValue Campaign discount PIM value
 */
const calculateTotalMarginValueFromValue = (discountInputValue, discountImporterInputValue, totalDefaultMargin, totalMarginAccessories, totalMarginVarnish, campaignDiscountImporterValue, campaignDiscountValue) => {
    const totalImporterDiscount = campaignDiscountImporterValue + discountImporterInputValue;
    const totalCustomerDiscount = campaignDiscountValue + discountInputValue;
    const totalBasisMargin = totalDefaultMargin + totalMarginAccessories + totalMarginVarnish;
    return Math.round(totalBasisMargin - totalCustomerDiscount + totalImporterDiscount);
};
exports.calculateTotalMarginValueFromValue = calculateTotalMarginValueFromValue;
/**
 * Calculate the margin on accessories in value (kr)
 * @param priceAccessories
 * @param marginPercentage %
 */
const calculateMarginAccessoriesValue = (priceAccessories, marginPercentage) => {
    return Math.round((priceAccessories * marginPercentage) / 100);
};
exports.calculateMarginAccessoriesValue = calculateMarginAccessoriesValue;
const campaignImporter = (configuration, input) => {
    var _a;
    return Math.abs(((_a = configuration === null || configuration === void 0 ? void 0 : configuration.pricing) === null || _a === void 0 ? void 0 : _a.importerSupportExcludingVat) || 0) + ((input === null || input === void 0 ? void 0 : input.importerDiscountValue) || 0);
};
exports.campaignImporter = campaignImporter;
const campaignDiscount = (configuration, input) => {
    var _a;
    return Math.abs(((_a = configuration === null || configuration === void 0 ? void 0 : configuration.pricing) === null || _a === void 0 ? void 0 : _a.customerAdvantageExcludingVat) || 0) + ((input === null || input === void 0 ? void 0 : input.discountValue) || 0);
};
exports.campaignDiscount = campaignDiscount;
const campaginImporterPercentage = (configuration, input, order) => {
    const totalCustomerPrice = (0, financing_1.getCalculationPriceByType)(order, enums_1.FinancingType.CASH);
    if (totalCustomerPrice === 0)
        return 0;
    return +(((0, exports.campaignImporter)(configuration, input) / totalCustomerPrice) * 100).toFixed(1);
};
exports.campaginImporterPercentage = campaginImporterPercentage;
const campaginDiscountPercentage = (configuration, input, order) => {
    var _a, _b;
    const indicativePrice = ((_a = configuration === null || configuration === void 0 ? void 0 : configuration.pricing) === null || _a === void 0 ? void 0 : _a.indicativePrice) || 0;
    if (indicativePrice === 0)
        return 0;
    const priceVarnish = ((_b = order === null || order === void 0 ? void 0 : order.options[0]) === null || _b === void 0 ? void 0 : _b.priceExcludingVat) || 0;
    return +(((0, exports.campaignDiscount)(configuration, input) / (indicativePrice + priceVarnish)) * 100).toFixed(1);
};
exports.campaginDiscountPercentage = campaginDiscountPercentage;
//# sourceMappingURL=margins.js.map